import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CircleSlashIcon } from '@/shared/ui/icons';
import { Button } from '@/shared/ui/buttons/Button';

export const WidgetsNotFoundMain = () => {
  const { t } = useTranslation('notFound');
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <CircleSlashIcon className="h-12 w-12 text-ink-faint" aria-hidden />
        <h1 className="text-xl font-semibold text-ink">{t('title')}</h1>
        <p className="text-sm text-ink-muted">{t('description')}</p>
        <Button onClick={() => navigate('/parcels')} className="mt-3">
          {t('goHome')}
        </Button>
      </div>
    </div>
  );
};
